"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.form.title.label': 'Titolo della Domanda <span class="text-danger">*</span>',
    'question.form.title.placeholder': 'Inserisci il titolo della domanda',
    'question.form.type.label': 'Tipo di Domanda',
    'question.form.type.placeholder': 'Seleziona il tipo di domanda',
    'question.form.required.label': 'Richiesto',
    'question.form.description.label': 'Descrizione (Opzionale)',
    'question.form.description.placeholder': 'Inserisci la descrizione della domanda',
    'question.form.options.label': 'Opzioni',
    'question.form.options.add': 'Aggiungi Opzione',
    'question.form.option.value.placeholder': 'Valore dell\'opzione',
    'question.form.option.label.placeholder': 'Etichetta dell\'opzione',
    'question.form.option.remove': 'Rimuovi opzione',
    'question.form.options.empty': 'Nessuna opzione aggiunta ancora. Clicca "Aggiungi Opzione" per iniziare.',
};
